define('gigaset/fx-engine',[
	"jquery"
], function(
	$
) {
	function FX() {}
	FX.prototype = {

		transitionBlend: function(from, to, ms, callback) {

			var fromContent = $( from ),
				toContent = $( to ),
				original = fromContent.wrapAll( '<div class="fx-blend-wrapper" style="position: absolute; left: 0; top: 0"></div>').parent(),
				replacement = toContent.wrapAll( '<div class="fx-blend-wrapper" style="position: absolute; left: 0; top: 0; display: none"></div>').parent();

			replacement.insertBefore( original );

			var wrapper = $( '.fx-blend-wrapper');
			wrapper.wrapAll( '<div class="fx-blend-main-wrapper" style="position: relative"></div>' );

			var fixedHeight = wrapper.outerHeight( true );
			$( '.fx-blend-main-wrapper' ).outerHeight( fixedHeight );

			original.fadeOut( ms, function() {
				$( this ).remove();
			} );
			replacement.fadeIn( ms, function() {
				toContent.unwrap().unwrap();
				if (typeof callback === 'function') callback();
			} );

		}

	};

	return new FX;

});
